import { render, staticRenderFns } from "./QuoteResumeButtons.vue?vue&type=template&id=2571bb98&scoped=true&"
import script from "./QuoteResumeButtons.vue?vue&type=script&lang=js&"
export * from "./QuoteResumeButtons.vue?vue&type=script&lang=js&"
import style0 from "./QuoteResumeButtons.vue?vue&type=style&index=0&id=2571bb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571bb98",
  null
  
)

export default component.exports